export var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};